import { MyModal } from '~/components/ui/MyModal'
import styled from 'styled-components'
import { useEffect, useState } from 'react'
import PaySuccessCard from '~/components/pages/order/PaySuccessCard'
import { useImperativeQuery } from '~/hooks/useImperativeQuery'
import { GET_RECHARGE_RESULT } from '~/graphqls/gqls'
import {
  getRechargeResult,
  getRechargeResultVariables,
  rechargeBalance_orderModule_copyrightRechargeBalance,
} from '~/graphqls/types'
import { ScanPayCard } from '~/components/pages/order/ScanPayCard'

const StyledPayMain = styled.div`
  display: flex;
  flex-direction: column;
  height: 400px;
  align-items: center;
  justify-content: center;
  text-align: center;
`

export const ScanPayModal: React.FC<{
  payInfo: rechargeBalance_orderModule_copyrightRechargeBalance | null
  amount: number
  icon: string
  visible: boolean
  setVisible: React.Dispatch<React.SetStateAction<boolean>>
}> = ({ visible, setVisible, payInfo, amount, icon }) => {
  const [paySuccessVisible, setPaySuccessVisible] = useState(false)

  const getRechargeResult = useImperativeQuery<
    getRechargeResult,
    getRechargeResultVariables
  >(GET_RECHARGE_RESULT)

  useEffect(() => {
    if (!visible) return

    const timer = setInterval(() => {
      if (!paySuccessVisible) {
        getRechargeResult({
          id: payInfo?.orderId,
          orderNo: payInfo?.orderNo,
        }).then(data => {
          if (data.data.orderModule?.status) {
            setPaySuccessVisible(true)
            clearInterval(timer)

            setTimeout(() => {
              location.reload()
            }, 3000)
          }
        })
      }
    }, 3000)

    return () => {
      clearInterval(timer)
    }
  }, [visible, paySuccessVisible])

  return (
    <MyModal
      visible={visible}
      title="扫码支付"
      onCancel={() => setVisible(false)}
      dark={true}
      maskStyle={{
        backgroundColor: 'rgba(0,0,0,0.8)',
      }}
      width={448}
      footer={null}
      zIndex={100000}
    >
      <StyledPayMain>
        <ScanPayCard amount={amount} icon={icon} url={payInfo?.payInfo || ''} />
        {paySuccessVisible && (
          <PaySuccessCard
            visible={paySuccessVisible}
            setVisible={setPaySuccessVisible}
          />
        )}
      </StyledPayMain>
    </MyModal>
  )
}
